import { Injectable } from '@angular/core';
import { SurveyService } from './survey.service';

@Injectable({ providedIn: 'root' })
export class SurveyResolver {
  constructor(private surveyService: SurveyService) {}

  resolve() {
    return this.surveyService.fetchAllSurveys(true, true, false, true);
  }
}
